const Faq = () => {
  const faqItems = [...document.querySelectorAll(".faq__item")];

  if (faqItems.length > 0 ) {
    faqItems.forEach((faqItem) => {
      const question = faqItem.querySelector(".faq__item-question");

      question.addEventListener("click", () => {
        const existedOpenedItem = faqItems.filter(item => item.classList.contains('opened'))[0];
        if (existedOpenedItem !== faqItem) {
          existedOpenedItem?.classList.remove('opened');
        }

        faqItem.classList.toggle("opened");
      });
    })
  }
}

export default Faq;

